import { ref } from "vue";

const isDocumentVisible = ref(true);
const isEventHandlerBound = false;

/**
 * Binds an event handler to listen for visibility change and updates the isDocumentVisible ref accordingly.
 */
const bindEventHandler = () => {
    document.addEventListener("visibilitychange", () => {
        isDocumentVisible.value = !document.hidden;
    });
};

/**
 * Function that checks if the event handler is bound and calls the bindEventHandler function if not.
 *
 * @return {Ref<boolean>} Ref object containing the visibility status of the document
 */
export const usePageVisibility = () => {
    if (!isEventHandlerBound) {
        bindEventHandler();
    }

    return { isDocumentVisible };
};
